module.exports = __webpack_public_path__ + "static/media/S (109).21173d35.jpg";